import { RegistrationSession, Session } from "@/api/dtos";
import { Box, Divider, Typography, styled } from "@mui/material";
import { FC, ReactNode, useMemo } from "react";
import { ISession } from "..";
import SpeakerSessionView from "./SpeakerSessionView";

interface ISessionGroupProps {
    sessions: ISession[];
    title: ReactNode;
    included?: boolean;
    optional?: boolean;
    isSpeaker?: boolean;
    isCap: boolean;
    isTAndECSpeaker?: boolean;
    hideAdditionalAttendees?: boolean;
    updateSelectedSessions: (session: Session, selectedSession?: RegistrationSession, selectedSessionIndex?: number, included?: boolean, optional?: boolean) => void;
}

const SessionGroupBox = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));


const SpeakerSessionGroup: FC<ISessionGroupProps> = ({
    title,
    sessions,
    included,
    optional,
    isSpeaker,
    isTAndECSpeaker,
    isCap,
    hideAdditionalAttendees,
    updateSelectedSessions
}) => {
    
    const sortedSessions = useMemo(() => {
        return [...sessions].sort((a, b) => {
            
            const EarlyCareerDinner = 27;
            // Check if either session has the special ID
            if (a.session.id === EarlyCareerDinner && b.session.id !== EarlyCareerDinner) {
                return 1; // a should come after b
            }
            if (a.session.id !== EarlyCareerDinner && b.session.id === EarlyCareerDinner) {
                return -1; // b should come after a
            }

            if (a.session.startTime === b.session.startTime) {
                if (a.session.endTime === b.session.endTime) {
                    return a.session.name! < b.session.name! ? -1 : 1 
                }
                else {
                    return a.session.endTime! < b.session.endTime! ? -1 : 1 
                }
            }
            else {
                return a.session.startTime! < b.session.startTime! ? -1 : 1 
            }
        })
    }, [sessions]);

    return (
        <>
            <Divider />
            <SessionGroupBox>
                <Typography variant="h6" color="secondary">
                    {title}
                </Typography>
                {
                    sortedSessions.map((session, i) => {

                        return (
                            <SpeakerSessionView 
                                key={session.session.id}
                                session={session.session}
                                selectedSession={session.selectedSession}
                                selectedSessionIndex={session.selectedSessionIndex}
                                initialSession={session.initialSession}
                                initialSessionIndex={session.initialSessionIndex}
                                included={included}
                                optional={optional}
                                hideAdditionalAttendees={hideAdditionalAttendees}
                                updateSelectedSessions={updateSelectedSessions}
                                isSpeaker={isSpeaker ?? false}
                                isCap={isCap ?? false}
                                isTAndECSpeaker={isTAndECSpeaker ?? false}
                            />
                        )
                    })
                }
            </SessionGroupBox>
        </>
    );
};

export default SpeakerSessionGroup;